<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Entrar</p>
        <div class="dropup-menu">
          <ion-item class="form-item mb-3 mt-0" lines="none">
            <input
              type="email"
              placeholder="Email"
              :value="email"
              @focus="hideSocial"
              @input="email = $event.target.value"
            />
          </ion-item>
          <ion-item class="form-item mb-3 mt-0" lines="none">
            <input
              type="password"
              placeholder="Senha"
              :value="password"
              @input="password = $event.target.value"
            />
          </ion-item>
          <div class="main-button-sm">
            <ion-button
              expand="block"
              mode="ios"
              shape="round"
              @click="signIn({
                signinMethod: 'email',
                signinData: {
                  email: email,
                  password: password
                }
              })"
            >Entrar</ion-button>
          </div>
          <p class="mt-2 ion-text-center text-sm">
            Esqueceu a senha?
            <a class="cursor-pointer" @click="gotoForgotPassword">Redefinir</a>
          </p>
          <div class="separator mt-4 mb-4" :class="socialButtonsClass">OU</div>
          <div class="social-buttons" :class="socialButtonsClass">
            <div
              class="square-button facebook mr-1"
              :class="facebookClass"
              @click="signIn({
              signinMethod: 'facebook'
            })"
            >
              <ion-icon name="logo-facebook" class="social-icon"></ion-icon>
            </div>
            <div
              class="square-button google ml-1"
              @click="signIn({
              signinMethod: 'google'
            })"
            >
              <ion-icon name="logo-google" class="social-icon"></ion-icon>
            </div>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// capacitor
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// moment
import moment from "moment";
moment.locale("pt-br");
// services
import authService from "@/services/auth/auth.js";
// component
export default {
  name: "LoginUser",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      email: null,
      password: null,
      socialButtonsClass: "",
      facebookClass: ""
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    gotoForgotPassword() {
      this.$router.push({
        name: "Forgot Password"
      });
    },
    hideSocial() {
      this.socialButtonsClass = "d-none";
    },
    async signIn(options) {
      const instance = this;
      instance.startLoading();
      try {
        const response = await authService({
          action: "signin",
          options: options
        });
        instance.isLoading = false;
        if (response === "ok") {
          instance.isLoading = false;
          instance.$router.push({
            name: "Meal Plan"
          });
        } else {
          if (response === "user doesnt exist") {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Usuário não encontrado. Tem certeza que inseriu as informações corretas?"
            };
          } else if (response === "user is admin") {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Não é possível acessar o app com a conta de administrador."
            };
          } else if (response === "missing information") {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message: "Por favor, insira todas as informações necessárias."
            };
          } else {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message: "Senha incorreta. Por favor, tente novamente."
            };
          }
          setTimeout(() => {
            instance.clearNotification();
          }, 3000);
        }
      } catch (e) {
        console.log(e);
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message:
            "Ocorreu um erro ao realizar esta operação. Por favor, tente novamente."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async mounted() {
    const instance = this;
    const today = new Date();
    const finalDate = new Date("02/03/2020");
    if (moment(today).isBefore(finalDate)) {
      instance.socialButtonsClass = "d-none";
    }
    const info = await Device.getInfo();
    const platform = info.platform;
    if (platform === "android") {
      instance.facebookClass = "d-none";
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    var(--bg-color-light)
  ) !important;
}

ion-item {
  --padding-start: 10vw;
  --padding-end: 10vw;
}

.dropup-menu {
  max-height: 80vh;
}
</style>